import LotThumbnail from "./lot-thumbnail";
export default LotThumbnail;